module.exports = __webpack_public_path__ + "static/media/757af1a9-4ec6-41a8-b386-7b6638b78d83.d98d36e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/757af1a9-4ec6-41a8-b386-7b6638b78d83.jpg
// module id = 828
// module chunks = 0